import areaIcon from '@/assets/area_icon.png';
import lineIcon from '@/assets/line_icon.png';
import parcelIcon from '@/assets/parcel_icon.png';
import pointIcon from '@/assets/waypoint_icon.png';
import type { SavedItemType } from '@/types';

export const SHAPE_ICONS: Record<SavedItemType, string> = {
    point: pointIcon,
    line: lineIcon,
    polygon: areaIcon,
    parcel: parcelIcon,
    none: pointIcon,
};
